namespace TabAurous.Inventory {
    export namespace OpeningStockItemsBOMService {
        export const baseUrl = 'OpeningStock/OpeningStockItemsBOM';

        export declare function Create(request: Serenity.SaveRequest<OpeningStockItemsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OpeningStockItemsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OpeningStockItemsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OpeningStockItemsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OpeningStock/OpeningStockItemsBOM/Create",
            Update = "OpeningStock/OpeningStockItemsBOM/Update",
            Delete = "OpeningStock/OpeningStockItemsBOM/Delete",
            Retrieve = "OpeningStock/OpeningStockItemsBOM/Retrieve",
            List = "OpeningStock/OpeningStockItemsBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>OpeningStockItemsBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
